<template>
  <CustomCreateDialog
      :dialogTitle="isEditing ? 'ویرایش سطح وفاداری' : 'افزودن سطح جدید'"
      dialogId="create-level-modal"
      :isOkDisabled="!isValid || submitting"
      :isLoading="submitting"
      @ok="submit"
      :ok-title="isEditing ? 'ویرایش' : 'افزودن'"
      @cancel="handleCancel"
      width="700px"
      maxWidth="95vw"
      minWidth="300px"
  >
    <b-row>
      <b-col cols="12" md="6">
        <TextInput
            inputId="levelName"
            inputLabel="نام سطح"
            inputPlaceholder="مثلاً برنز"
            v-model="form.name"
            :disabled="submitting"
        />
      </b-col>

      <b-col cols="12" md="3">
        <TextInput
            inputId="levelPriority"
            inputLabel="اولویت سطح"
            inputPlaceholder="0"
            type="number"
            v-model.number="form.priority"
            :disabled="submitting"
        />
      </b-col>

      <b-col cols="12" md="3">
        <CustomAppendText
            :isText="true"
            type="number"
            inputmode="numeric"
            inputId="levelDiscount"
            inputLabel="درصد تخفیف"
            inputPlaceholder="0"
            v-model="form.discount"
            :disabled="submitting"
        >
          <template #append> % </template>
        </CustomAppendText>
      </b-col>

      <b-col cols="12" md="6">
        <div class="form-group">
          <label class="form-label" for="levelAvatar">آواتار سطح</label>
          <LevelAvatarSelect
              :value="form.avatar"
              @input="form.avatar = $event"
              :disabled="submitting"
          />
        </div>
      </b-col>

      <b-col cols="12" class="mt-3">
        <div class="rule-section">
          <div class="rule-header d-flex align-items-center justify-content-between mb-2">
            <h6 class="mb-0">شرط ارتقا</h6>
            <b-form-checkbox
                v-model="upperEnabled"
                switch
                :disabled="submitting"
            >
              <small>{{ upperEnabled ? 'فعال' : 'غیرفعال' }}</small>
            </b-form-checkbox>
          </div>

          <div :class="['rule-content', { 'rule-disabled': !upperEnabled }]">
            <b-row>
              <b-col cols="12" md="4">
                <div class="form-group">
                  <label class="form-label" for="upperMonth">تعداد ماه متوالی</label>
                  <v-select
                      label="label"
                      :value="form.upperMonth"
                      @input="form.upperMonth = $event"
                      :options="monthOptions"
                      :reduce="(v) => v.value"
                      :clearable="false"
                      :disabled="!upperEnabled || submitting"
                      class="v-select-custom"
                      placeholder="انتخاب ماه"
                  />
                </div>
              </b-col>

<!--              <b-col cols="12" md="4">-->
<!--                <div class="form-group">-->
<!--                  <label class="form-label" for="upperUnit">شرط</label>-->
<!--                  <v-select-->
<!--                      label="name"-->
<!--                      :value="form.upperUnit"-->
<!--                      @input="form.upperUnit = $event"-->
<!--                      :options="compareOptionsHigh"-->
<!--                      :reduce="(v) => v.value"-->
<!--                      :clearable="false"-->
<!--                      :disabled="!upperEnabled || submitting"-->
<!--                      class="v-select-custom"-->
<!--                  />-->
<!--                </div>-->
<!--              </b-col>-->

              <b-col cols="12" md="4">
                <TextInput
                    inputId="upperValue"
                    inputLabel="ساعت فعالیت"
                    inputPlaceholder="مثلاً 8"
                    type="number"
                    v-model.number="form.upperValue"
                    :disabled="!upperEnabled || submitting"
                />
              </b-col>
            </b-row>

<!--            <div v-if="upperEnabled && hasUpperPreview" class="preview-section mt-2">-->
<!--              <b-badge variant="light" class="preview-badge mr-1">-->
<!--                {{ Number(form.upperMonth || 0) }} ماه متوالی-->
<!--              </b-badge>-->
<!--              <b-badge variant="info" class="preview-badge">-->
<!--                فعالیت {{ compareText(form.upperUnit) }} {{ Number(form.upperValue || 0) }} ساعت-->
<!--              </b-badge>-->
<!--            </div>-->
          </div>
        </div>
      </b-col>

      <b-col cols="12" class="mt-3">
        <div class="rule-section">
          <div class="rule-header d-flex align-items-center justify-content-between mb-2">
            <h6 class="mb-0">شرط تنزل</h6>
            <b-form-checkbox
                v-model="lowerEnabled"
                switch
                :disabled="submitting"
            >
              <small>{{ lowerEnabled ? 'فعال' : 'غیرفعال' }}</small>
            </b-form-checkbox>
          </div>

          <div :class="['rule-content', { 'rule-disabled': !lowerEnabled }]">
            <b-row>
              <b-col cols="12" md="4">
                <div class="form-group">
                  <label class="form-label" for="lowerMonth">تعداد ماه متوالی</label>
                  <v-select
                      label="label"
                      :value="form.lowerMonth"
                      @input="form.lowerMonth = $event"
                      :options="monthOptions"
                      :reduce="(v) => v.value"
                      :clearable="false"
                      :disabled="!lowerEnabled || submitting"
                      class="v-select-custom"
                      placeholder="انتخاب ماه"
                  />
                </div>
              </b-col>

<!--              <b-col cols="12" md="4">-->
<!--                <div class="form-group">-->
<!--                  <label class="form-label" for="lowerUnit">شرط</label>-->
<!--                  <v-select-->
<!--                      label="name"-->
<!--                      :value="form.lowerUnit"-->
<!--                      @input="form.lowerUnit = $event"-->
<!--                      :options="compareOptionsLess"-->
<!--                      :reduce="(v) => v.value"-->
<!--                      :clearable="false"-->
<!--                      :disabled="!lowerEnabled || submitting"-->
<!--                      class="v-select-custom"-->
<!--                  />-->
<!--                </div>-->
<!--              </b-col>-->

              <b-col cols="12" md="4">
                <TextInput
                    inputId="lowerValue"
                    inputLabel="ساعت فعالیت"
                    inputPlaceholder="مثلاً 2"
                    type="number"
                    v-model.number="form.lowerValue"
                    :disabled="!lowerEnabled || submitting"
                />
              </b-col>
            </b-row>

<!--            <div v-if="lowerEnabled && hasLowerPreview" class="preview-section mt-2">-->
<!--              <b-badge class="preview-badge mr-1">-->
<!--                {{ Number(form.lowerMonth || 0) }} ماه متوالی-->
<!--              </b-badge>-->
<!--              <b-badge variant="info" class="preview-badge">-->
<!--                فعالیت {{ compareText(form.lowerUnit) }} {{ Number(form.lowerValue || 0) }} ساعت-->
<!--              </b-badge>-->
<!--            </div>-->
          </div>
        </div>
      </b-col>
    </b-row>
  </CustomCreateDialog>
</template>

<script>
import vSelect from "vue-select";
import { BRow, BCol, BFormCheckbox, BBadge } from "bootstrap-vue";
import LevelAvatarSelect from "@core/components/loyalty/LevelAvatarPicker.vue";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";

export default {
  name: "CreateLevelModal",

  components: {
    vSelect,
    BRow,
    BCol,
    BFormCheckbox,
    BBadge,
    LevelAvatarSelect,
    CustomCreateDialog,
    TextInput,
    CustomAppendText
  },

  props: {
    submitting: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentEditId: 0,
      upperEnabled: false,
      lowerEnabled: false,
      form: {
        id: 0,
        priority: 0,
        name: "",
        avatar: "",
        discount: 0,
        upperMonth: 0,
        upperValue: 0,
        lowerMonth: 0,
        lowerValue: 0
      },
      monthOptions: [
        { label: "1 ماه", value: 1 },
        { label: "2 ماه", value: 2 },
        { label: "3 ماه", value: 3 },
        { label: "4 ماه", value: 4 },
        { label: "5 ماه", value: 5 },
        { label: "6 ماه", value: 6 },
        { label: "7 ماه", value: 7 },
        { label: "8 ماه", value: 8 },
        { label: "9 ماه", value: 9 },
        { label: "10 ماه", value: 10 },
        { label: "11 ماه", value: 11 },
        { label: "12 ماه", value: 12 }
      ],
      compareOptionsHigh: [
        { name: "برابر", value: 0 },
        { name: "برابر و بالاتر", value: 1 },
        { name: "بالاتر", value: 3 },
      ],
      compareOptionsLess: [
        { name: "برابر", value: 0 },
        { name: "برابر و پایین تر", value: 2 },
        { name: "پایینتر", value: 4 },
      ]
    };
  },

  computed: {
    isEditing() {
      return Number(this.currentEditId || 0) > 0;
    },

    isValid() {
      const nameOk = String(this.form.name || "").trim().length >= 2;
      const discount = Number(this.form.discount || 0);
      const discountOk = discount >= 0 && discount <= 100;
      return nameOk && discountOk;
    },

    hasUpperPreview() {
      return Number(this.form.upperMonth || 0) > 0 || Number(this.form.upperValue || 0) > 0;
    },

    hasLowerPreview() {
      return Number(this.form.lowerMonth || 0) > 0 || Number(this.form.lowerValue || 0) > 0;
    }
  },

  watch: {
    upperEnabled(newVal) {
      if (!newVal) {
        this.form.upperMonth = 0;
        this.form.upperValue = 0;
      }
    },

    lowerEnabled(newVal) {
      if (!newVal) {
        this.form.lowerMonth = 0;
        this.form.lowerValue = 0;
      }
    }
  },

  methods: {
    openForCreate() {
      this.currentEditId = 0;
      this.upperEnabled = false;
      this.lowerEnabled = false;
      this.form = {
        id: 0,
        priority: 0,
        name: "",
        avatar: "",
        discount: 0,
        upperMonth: 0,
        upperValue: 0,
        lowerMonth: 0,
        lowerUnit: 0,
      };
    },

    openForEdit(item) {
      if (!item) {
        this.openForCreate();
        return;
      }

      const id = Number(item.id || 0);
      this.currentEditId = id;

      const upperMonth = Number(item.upperMonth || 0);
      const upperValue = Number(item.upperValue || 0);
      const lowerMonth = Number(item.lowerMonth || 0);
      const lowerValue = Number(item.lowerValue || 0);

      this.upperEnabled = upperMonth > 0 || upperValue > 0;
      this.lowerEnabled = lowerMonth > 0 || lowerValue > 0;

      this.form = {
        id: id,
        priority: Number(item.priority || 0),
        name: String(item.name || ""),
        avatar: String(item.avatar || ""),
        discount: Number(item.discount || 0),
        upperMonth: upperMonth,
        upperValue: upperValue,
        lowerMonth: lowerMonth,
        lowerValue: lowerValue,
      };
    },

    compareText(value) {
      const n = Number(value || 0);
      switch (n) {
        case 0: return "=";
        case 1: return "≥";
        case 2: return "≤";
        case 3: return ">";
        case 4: return "<";
        default: return "≥";
      }
    },

    buildPayload() {
      const payload = {
        id: Number(this.form.id || 0),
        priority: Number(this.form.priority || 0),
        name: String(this.form.name || "").trim(),
        avatar: String(this.form.avatar || ""),
        discount: Number(this.form.discount || 0),
      };

      if (this.upperEnabled) {
        payload.upperMonth = Number(this.form.upperMonth || 0);
        payload.upperValue = Number(this.form.upperValue || 0);
      }

      if (this.lowerEnabled) {
        payload.lowerMonth = Number(this.form.lowerMonth || 0);
        payload.lowerValue = Number(this.form.lowerValue || 0);
      }

      return payload;
    },

    submit() {
      if (!this.isValid || this.submitting) {
        return;
      }
      this.$emit("submit", this.buildPayload());
    },

    handleCancel() {
      this.$emit("cancel");
    },

    reset() {
      this.openForCreate();
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.form-label {
  font-size: 12px;
  font-weight: 900;
  color: #374151;
  margin-bottom: 6px;
  display: block;
}

.rule-section {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
}

.rule-header {
  border-bottom: 1px solid #eef2f7;
  padding-bottom: 8px;
}

.rule-header h6 {
  font-size: 13px;
  font-weight: 900;
  color: #111827;
}

.rule-content {
  padding-top: 12px;
  transition: opacity 0.2s ease;
}

.rule-disabled {
  opacity: 0.5;
  pointer-events: none;
}

.v-select-custom :deep(.vs__dropdown-toggle) {
  height: 44px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 2px 10px;
  display: flex;
  align-items: center;
}

.preview-section {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.preview-badge {
  font-size: 12px;
  font-weight: 900;
  padding: 6px 12px;
  border-radius: 20px;
}
</style>